﻿
export namespace EditorAddonUtils {
    export function ensureInputGroup(editorElement: HTMLElement): HTMLElement {
        let group = editorElement.closest<HTMLElement>('.input-group');

        if (!group) {
            group = document.createElement('div');
            group.className = 'input-group';
            editorElement.insertAdjacentElement('beforebegin', group);
            group.appendChild(editorElement);
        }

        return group;
    }

    export function appendToInputGroup(editorElement: HTMLElement, addon: HTMLElement, before?: boolean) {
        if (!editorElement)
            return;
        const group = ensureInputGroup(editorElement);
        before ? group.prepend(addon) : group.append(addon);
    }

    export function ensureInputVStack(editorElement: HTMLElement): HTMLElement {
        let group = ensureInputGroup(editorElement);
        let vstack = group.closest<HTMLElement>('.input-vstack');

        if (!vstack) {
            vstack = document.createElement('div');
            vstack.className = 'input-vstack vstack';
            group.insertAdjacentElement('beforebegin', vstack);
            vstack.appendChild(group);
        }

        return vstack;
    }

    export function appendToInputVStack(editorElement: HTMLElement, addon: HTMLElement, before?: boolean) {
        if (!editorElement)
            return;
        const group = ensureInputVStack(editorElement);
        before ? group.prepend(addon) : group.append(addon);
    }
}